import { render, staticRenderFns } from "./_ChannelPreview.vue?vue&type=template&id=64c11d26&scoped=true&"
import script from "./_ChannelPreview.vue?vue&type=script&lang=ts&"
export * from "./_ChannelPreview.vue?vue&type=script&lang=ts&"
import style0 from "./_ChannelPreview.vue?vue&type=style&index=0&id=64c11d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c11d26",
  null
  
)

export default component.exports